import React from 'react'
import MainLayout from '../../containers/MainLayout'

import { langTexts } from './locals'
import image from '../../assets/images/svg_icons/construccion.svg'
import { ReactComponent as Logo } from '../../assets/images/svg_icons/construccion.svg'
import { connect } from 'react-redux'

import './index.css'
import { Link } from 'react-router-dom'
import { getURLByRouteName } from '../../utils/routes'

const Construction = props => {
  const { lang } = props.settings
    , texts = langTexts[lang]

  return <MainLayout id='construction' className='' redLabel={false} logo={<Logo />}>
    <div className='construction__container'>
      <img src={image} alt='construcción' />
      <h1>{texts.title}</h1>
      <p className='gray-color'>{texts.desc}</p>
      <Link className='about-us__download-btn' to={getURLByRouteName('home')}>{texts.btn}</Link>
    </div>
  </MainLayout>
}

const mapStateToProps = state => ({
  settings: state.settings
})

export default connect(mapStateToProps)(Construction)